import { isConnectedUserInfo, isUserGold, UserInfo } from '../../../server';

type productFreeShippingBusinessRulesArgs = {
    price?: number;
    threshold?: number;
    userInfo?: UserInfo;
};

export const freeShippingBusinessRules = ({
    price,
    threshold,
    userInfo,
}: productFreeShippingBusinessRulesArgs): boolean => {
    const isGoldUser = isConnectedUserInfo(userInfo) && isUserGold(userInfo);
    return (threshold ? price && price >= threshold : false) || isGoldUser;
};
